<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Roles</li>
</ol>

<h1 class="page-header"><i class="fas fa-user-shield"></i> Administración de Roles</h1>

<panel [noButton]="true">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <span class="fs-5 fw-600">Lista de roles</span>
        <button class="btn btn-sm btn-primary" (click)="open(modalRoleForm)"><i class="fas fa-plus me-1"></i>Nuevo rol</button>
    </div>

    <table class="table table-striped table-hover">
        <thead>
            <tr>
                <th class="text-center">N°</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th class="text-center col-1"><i class="fas fa-cogs"></i></th>
            </tr>
        </thead>
        <tbody>
            @if(roles?.length > 0){
            @for(role of roles; track role.id; let i = $index){
            <tr>
                <td class="text-center">{{ (role.index ?? i) + 1 }}</td>
                <td class="fw-500">{{ role.name }}
                  @if (hasNoMenus(role)) {
                    <span class="badge bg-warning text-dark ms-1">Sin menús</span>
                  }
                </td>
                <td>{{ role.description }}</td>
                <td class="text-center text-nowrap">
                    <button class="btn btn-xs btn-ghost" (click)="moveUp(role, i)" [disabled]="i === 0"
                        triggers="hover" ngbTooltip="Subir">
                        <i class="fas fa-chevron-up"></i>
                    </button>
                    <button class="btn btn-xs btn-ghost" (click)="moveDown(role, i)" [disabled]="i === roles.length - 1"
                        triggers="hover" ngbTooltip="Bajar">
                        <i class="fas fa-chevron-down"></i>
                    </button>
                    <button class="btn btn-xs btn-ghost" (click)="open(modalRoleForm, role)" triggers="hover" ngbTooltip="Editar">
                        <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn btn-xs btn-ghost" (click)="openClone(modalCloneMenus, role)" triggers="hover" ngbTooltip="Clonar menús de otro rol">
                        <i class="fas fa-copy"></i>
                    </button>
                    <button class="btn btn-xs btn-ghost" (click)="enabledRole(role)" triggers="hover" [ngbTooltip]="role.enabled ? 'Deshabilitar' : 'Habilitar'">
                        <i class="fas" [class.fa-toggle-on]="role.enabled" [class.fa-toggle-off]="!role.enabled"></i>
                    </button>
                </td>
            </tr>
            }
            } @else {
            <tr>
                <td colspan="4" class="text-center text-muted">No hay roles registrados</td>
            </tr>
            }
        </tbody>
    </table>
</panel>


<ng-template #modalRoleForm let-c="close" let-d="dismiss">
    <div class="modal-header">
        <span class="fs-3 fw-700">{{ newRoleForm.value.id ? 'Editar Rol' : 'Nuevo Rol' }}</span>
    </div>
    <div class="modal-body" [formGroup]="newRoleForm">
        <div class="row g-3">
            <div class="col-md-6">
                <label class="form-label fw-600">Nombre <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Nombre del rol" formControlName="name" />
            </div>
            <div class="col-md-6">
                <label class="form-label fw-600">Descripción <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Descripción del rol" formControlName="description" />
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-outline-secondary" (click)="d('Cross click')"><i class="fas fa-times me-1"></i> Cancelar</button>
        <button class="btn btn-primary" (click)="d('Cross click'); saveRole()"><i class="fas fa-save me-1"></i> Guardar</button>
    </div>
</ng-template>

<ng-template #modalCloneMenus let-d="dismiss">
    <div class="modal-header">
        <span class="fs-3 fw-700">Clonar menús hacia {{ cloneTarget?.name }}</span>
    </div>
    <div class="modal-body">
        <label class="form-label fw-600">Rol origen</label>
        <ng-select [items]="cloneSources" bindLabel="name" bindValue="id"
            [(ngModel)]="cloneSourceId" [ngModelOptions]="{standalone: true}"
            placeholder="Seleccione rol origen" appendTo="body"></ng-select>
        <small class="text-muted">Se reemplazan los menús actuales del rol destino.</small>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-secondary" (click)="d('Cross click')"><i class="fas fa-times me-1"></i> Cancelar</button>
        <button class="btn btn-primary" (click)="d('Cross click'); confirmClone()" [disabled]="!cloneSourceId"><i class="fas fa-copy me-1"></i> Clonar</button>
    </div>
</ng-template>